import { RootDispatch } from 'storage/store';

import { KISA_MIGRATION_LOGIN } from './featureTogglesNames';

const managingFeatureToggles = (
  featureToggleName: string,
  featureState: boolean,
  dispatch: RootDispatch
) => {
  switch (featureToggleName) {
    case KISA_MIGRATION_LOGIN: {
      if (featureState) {
        dispatch.application.enableKisaLoginPageVisibility();
      } else {
        dispatch.application.disableKisaLoginPageVisibility();
      }
      break;
    }
    default:
      break;
  }
};

export default managingFeatureToggles;
